import React from "react";

// interface ImageWithDescriptionProps {
// 	headerImages: any;
// }

export const ImageWithDescription = ({ headerImages } /*: ImageWithDescriptionProps */) => {
	const image = headerImages?.[0];
	if (!image) return null;
	const formatDescription = (description) => {
		return description.split("\n").map((line, idx) => (
			<React.Fragment key={idx}>
				{line}
				{idx !== description.split("\n").length - 1 && <br />}
			</React.Fragment>
		));
	};

	return (
		<>
			<div className="relative h-[400px] lg:h-[550px] w-full md:w-[50%]">
				<img
					className="absolute bottom-0 lg:right-20 h-full w-full object-contain"
					src={image.imageUrl}
					alt={image.alt}
				/>
				{image?.description && <div className="absolute left-[-5%] bottom-10 p-2 text-left w-auto z-4 text-white rounded-sm">
					{formatDescription(image.description)}
				</div>}
			</div>
			
		</>
	);
};
